import styled from 'styled-components';
import { device, typography } from '@/styles/helpers';
import { ScProviders } from '../Providers/styled';

export const ScProvidersWrapper = styled.div`
  ${ScProviders} {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 4px;

    @media (${device.mobile}) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    & .providers-wrapper {
      height: 56px;
      gap: 4px;
      background-color: rgba(50, 52, 68, 0.5);

      & .provider-img {
        height: 22px;
        width: 22px;
      }

      & .provider-name {
        ${typography.caption1bold}
        text-transform: capitalize;
        color: ${({ theme }) => theme.color9};
      }

      @media (${device.mobile}) {
        max-width: 100%;
      }
    }
  }
`;
